// extracted by mini-css-extract-plugin
module.exports = {"title-section":"_1iTAwX9PSu","titleSection":"_1iTAwX9PSu","table":"_14TkSwZnhM","status":"_3OrH4wmVBn"};
    if(module.hot) {
      // 1614934717838
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  